import {WaveLoader} from '@wandb/weave/components/Loaders/WaveLoader';
import React from 'react';

import {
  LogViewerFetchMoreError,
  type OnRetryFetchMore,
} from './LogViewerFetchMoreError';

export type RenderFetchMoreError = (_: {
  error: Error | string;
  isRetrying: boolean;
  onRetry?: OnRetryFetchMore;
}) => React.ReactNode;

export interface LogViewerPageLoaderProps {
  error?: Error | string;
  isLoading: boolean;
  isRetrying: boolean;
  onRetry?: OnRetryFetchMore;
  renderError?: RenderFetchMoreError;
}

export const LogViewerPageLoader: React.FC<LogViewerPageLoaderProps> = ({
  error,
  isLoading,
  isRetrying,
  onRetry,
  renderError,
}) => {
  if (error) {
    return renderError ? (
      <>{renderError({error, isRetrying, onRetry})}</>
    ) : (
      <LogViewerFetchMoreError
        error={error}
        isRetrying={isRetrying}
        onRetry={onRetry}
      />
    );
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <WaveLoader size="small" />
      </div>
    );
  }

  return null;
};
